var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8479 6.99982C11.5358 6.99982 9.9559 8.74294 10.3348 10.8731L10.9128 14.0983C11.1408 15.3764 12.4606 16.4235 13.8479 16.4235C15.2351 16.4235 16.5582 15.3794 16.7829 14.0983L17.3577 10.8731C17.7367 8.74294 16.1568 6.99982 13.8447 6.99982H13.8479Z",
    stroke: "#9B9B9B",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.054 17.9116L17.0336 16.6605C16.1891 17.4316 15.0523 17.9236 13.8481 17.9236C12.6439 17.9236 11.5071 17.4316 10.6626 16.6605L6.63891 17.9116C5.89391 18.1426 5.28378 18.9347 5.28378 19.6667V23H22.4092V19.6667C22.4092 18.9347 21.799 18.1426 21.054 17.9116Z",
    stroke: "#9B9B9B",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1287 4.99908C17.1717 4.99908 16.3497 5.31111 15.7299 5.81514C16.5487 6.09416 17.2777 6.55319 17.8364 7.16823C18.7998 8.22731 19.2012 9.66741 18.9411 11.1195L18.3663 14.3447C18.3631 14.3627 18.3534 14.3837 18.3502 14.4017C19.654 14.2967 20.8486 13.3067 21.0637 12.0976L21.6385 8.87235C22.0174 6.7422 20.4375 4.99908 18.1287 4.99908Z",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85642 7.16843C10.6335 6.31337 11.7286 5.75833 12.952 5.57532L13.0773 4.87327C13.4594 2.74312 11.8763 1 9.56741 1C7.25855 1 5.67542 2.74312 6.05434 4.87327L6.63236 8.09849C6.80898 9.10056 7.65995 9.94962 8.68433 10.2766C8.68112 9.12156 9.08573 8.02348 9.85642 7.16843Z",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12831 16.4899L9.68954 15.3828C9.52577 15.0528 9.3909 14.7108 9.32667 14.3478L8.88353 11.8576C7.93622 11.7106 7.06277 11.2846 6.37878 10.6635L2.35513 11.9146C1.61013 12.1456 1 12.9377 1 13.6697V17.003H5.12641C5.42826 16.7809 5.76544 16.6039 6.12831 16.4899Z",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3345 16.1892L21.314 14.6597C20.736 15.1848 20.0199 15.5688 19.2396 15.7668L21.5613 16.4899C22.9614 16.9279 24.0147 18.293 24.0147 19.6701V21.0022H26.6896V17.6689C26.6896 16.9369 26.0795 16.4203 25.3345 16.1892Z",
    stroke: "#D6D6D6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIconBlack);
export default __webpack_public_path__ + "static/media/UsersIconBlack.568f7c8fa6e0354759c7881aa863769a.svg";
export { ForwardRef as ReactComponent };